import SvgIcon from '@mui/material/SvgIcon';

/**
 * Photographer icon: matches MUI PersonSearch layout (person silhouette upper-left)
 * but with a camera in place of the magnifying glass at lower-right.
 *
 * Used by header creator-filter dropdown and by per-widget CreatorFilter so the
 * "filter by creator" affordance looks identical everywhere it appears.
 */
const PhotographerIcon = (props: any) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <defs>
      <mask id="cameraGapMask">
        {/* Show everything by default */}
        <rect x="0" y="0" width="24" height="24" fill="white" />
        {/* Cut out a slightly oversized camera silhouette so the torso/shoulders show a transparent gap behind the camera */}
        <rect x="13.4" y="14.4" width="10.2" height="7.7" rx="1.2" fill="black" />
        <path d="M16.2 14.8 L16.9 13.5 L20.1 13.5 L20.8 14.8 Z" fill="black" />
      </mask>
    </defs>
    {/* Person silhouette — but with the camera silhouette cut out via the mask */}
    <g mask="url(#cameraGapMask)">
      <circle cx="10" cy="8" r="4" fill="currentColor" />
      <path d="M2 18 C2 15.33 7.33 14 10 14 C12.67 14 18 15.33 18 18 L18 20 L2 20 Z" fill="currentColor" />
    </g>
    {/* Camera (drawn on top, full-opacity, so the gap shows around it) */}
    <rect x="14" y="15" width="9" height="6.5" rx="1" fill="currentColor" />
    <path d="M16.5 15 L17.2 13.8 L19.8 13.8 L20.5 15 Z" fill="currentColor" />
    {/* Lens */}
    <circle cx="18.5" cy="18.25" r="2.1" fill="currentColor" />
    {/* Inner lens detail: a contrasting hole in the middle */}
    <circle cx="18.5" cy="18.25" r="0.9" fill="rgba(0,0,0,0.55)" />
  </SvgIcon>
);

export default PhotographerIcon;
